import Accordion from 'globalcomponents/Accordion';
import { pageUrls } from 'globalconfig/constants/keys';
import { mediaUrls } from 'globalconfig/constants/mediaUrls';
import { findAndDeleteParentInJson, hasEnabledFeature } from 'globalutils/fmUtils';
import PropTypes from 'prop-types';
import React, { lazy, useEffect, useState } from 'react';
import Alerts from './Alerts';
import CsaViolation from './CSASnapshot';
import DailyLogComponent from './DailyLogs';
import DeveloperRequest from './DeveloperRequest';
import DriverBehavior from './DriverBehavior';
import DriverStatus from './DriverStatus';
import PotentialViolations from './PotentialViolations';
import RecentAccidents from './RecentAccidents';
import { checkServiceProvider } from './serviceProviderConfig';
import VehicleStatus from './VehicleStatus';

const layout = window?.$environment?.CURRENT_LAYOUT;
const GoogleMap = lazy(() => import(`globalcomponents/GoogleMap/${layout}`));
const Tab = lazy(() => import(`globalcomponents/UI/Tab/${layout}`));
const Icon = lazy(() => import(`globalcomponents/UI/Icon/${layout}`));
const CheckBox = lazy(() => import(`globalcomponents/UI/Toggle/${layout}`));

const Component = ({
  history,
  dashboard,
  clearAll,
  clearAllRecentAccidents,
  clearAllDailyLogs,
  refreshVehicleStatus,
  handleDeleteAlert,
  handleAcceptPermissionRequest,
  handleDeletePermissionRequest,
  callback,
  clearAllAlerts,
  enableNotification,
  Styled,
  accordion,
  dataList,
  iconsAsLink,
  mapRequired,
  i18n,
  getDriverStatus,
  getLatestLog,
  viewReport,
  refreshDriverStatusMap,
  getVehicleStatus,
  driverStatusColumn,
}) => {
  const SERVICE_PROVIDER = window.$environment.SERVICE_PROVIDER;

  const [notificationEnabled, setNotificationEnabled] = useState(false);
  const [value, setValue] = useState(0);
  const [sourceToDisplay, setSourceToDisplay] = useState([]);
  const [sourceList, setSourceList] = useState(dataList);
  const [viewOnMapFlg, setviewOnMapFlg] = useState(false);
  const [viewOnMap, setviewOnMap] = useState(null);

  useEffect(() => {
    if (!hasEnabledFeature('smoothTrackingEnabled')) {
      if (!hasEnabledFeature('geometrisEnabled')) {
        getDriverStatus({
          apiId: 'getDriverStatus',
          data: { isDashboard: true },
        });
      } else {
        getVehicleStatus({ apiId: 'getVehicleStatus' });
      }
      const interval = setInterval(() => {
        if (!hasEnabledFeature('geometrisEnabled')) {
          getDriverStatus({
            apiId: 'refreshDashboardMap',
            data: { isDashboard: true },
          });
        } else {
          getVehicleStatus({ apiId: 'refreshDashboardMap' });
        }
      }, 120000);
      return () => clearInterval(interval);
    }
  }, []);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  useEffect(() => {
    let data = dataList;
    if (!hasEnabledFeature('csaViolationFieldWaitingEnabled')) {
      data = findAndDeleteParentInJson(data, 'id', 'csaViolationFieldWaitingEnabled');
    }
    if (!hasEnabledFeature('geometrisEnabled')) {
      data = findAndDeleteParentInJson(data, 'dependency', 'geometrisEnabled');
    }
    if (!hasEnabledFeature('accidentWebEnabled')) {
      data = findAndDeleteParentInJson(data, 'dependency', 'accidentWebEnabled');
    }
    setSourceList(data);
  }, []);

  const driverBehavior = () => <DriverBehavior i18n={i18n} history={history} callback={callback} />;

  const vehicleStatus = () => (
    <>
      <div className="viewAll statusIcon">
        <Icon
          src={['SpireonNew', 'SpireonOld', 'OldUi'].includes(layout) ? mediaUrls.refreshIcon : mediaUrls?.refreshCircle}
          onClick={() =>
            refreshVehicleStatus({
              apiId: 'refreshVehicleStatus',
              data: { isVehicleStatusPageFlag: false },
            })
          }
          tooltip={i18n.t('common.refresh')}
          className="refresh-icon"
        />

        <Icon
          src={mediaUrls?.viewAll}
          onClick={() => history.push(pageUrls.vehicleStatusViewMore)}
          asLink={iconsAsLink}
          text={i18n.t('common.viewMore')}
          tooltip={i18n.t('common.viewMore')}
        />
      </div>
      <VehicleStatus
        i18n={i18n}
        vehicleStatus={dashboard?.data?.vehicleStatus?.infoItems || []}
        viewOnMap={(e) => viewOnMapClicked(e)}
        noPagination
        noSort
      />
    </>
  );
  const viewOnMapClicked = (e) => {
    setviewOnMap(e);
    setviewOnMapFlg((prevFlg) => {
      return !prevFlg;
    });
    document.body.scrollTop = 0;
    document.documentElement.scrollTop = 0;
  };

  const driverStatus = () => (
    <>
      <div className="viewAll statusIcon">
        <Icon
          src={['SpireonNew', 'SpireonOld', 'OldUi'].includes(layout) ? mediaUrls.refreshIcon : mediaUrls?.refreshCircle}
          onClick={() =>
            refreshDriverStatusMap({
              apiId: 'refreshDriverStatus',
            })
          }
          tooltip={i18n.t('common.refresh')}
          className="refresh-icon"
        />

        <Icon
          src={mediaUrls?.viewAll}
          onClick={() => history.push(pageUrls.driverStatusViewMore)}
          asLink={iconsAsLink}
          text={i18n.t('common.viewMore')}
          tooltip={i18n.t('common.viewMore')}
        />
      </div>
      <DriverStatus
        i18n={i18n}
        pageUrls={pageUrls}
        getLatestLog={getLatestLog}
        history={history}
        driverStatus={dashboard?.data?.driversOnDuty?.infoItems || []}
        columns={driverStatusColumn || null}
      />
    </>
  );

  useEffect(() => {
    localStorage.setItem('daltnot', dashboard?.data?.enableNotification);
  }, [dashboard?.data?.enableNotification]);

  const getIdValue = (event) => {
    setNotificationEnabled(event);
    if (dashboard.data.enableNotification === false) {
      localStorage.setItem('daltnot', event);
      return true;
    } else if (dashboard.data.enableNotification === true && localStorage.getItem('daltnot') === 'true') {
      localStorage.setItem('daltnot', event);
      return false;
    } else {
      localStorage.setItem('daltnot', event);
      return true;
    }
  };

  const alerts = () => (
    <>
      <div className="viewAll">
        {checkServiceProvider('component_alerts', SERVICE_PROVIDER, false) && (
          <>
            <CheckBox
              id="alertenableNotification"
              type="NormalGrey"
              label={i18n.t('dashboard.tabs.alerts.enableNotification')}
              checked={notificationEnabled}
              onClick={(event) => {
                enableNotification({
                  apiId: 'enableNotification',
                  data: {
                    id: getIdValue(event),
                  },
                  callback: callback,
                });
              }}
              className="enable"
            />
            <Icon
              src={mediaUrls?.clearAll}
              onClick={() =>
                clearAllAlerts({
                  apiId: 'clearAllAlerts',
                  callback: setValue(0),
                })
              }
              className="clearAll"
              asLink={iconsAsLink}
              text={i18n.t('common.clearAll')}
              tooltip={i18n.t('common.clearAll')}
            />
          </>
        )}
        <Icon
          src={mediaUrls?.viewAll}
          onClick={() => history.push(pageUrls.alertViewMore)}
          asLink={iconsAsLink}
          text={i18n.t('common.viewMore')}
          tooltip={i18n.t('common.viewMore')}
        />
      </div>
      <Alerts
        list={dashboard.data?.alerts?.dashboardAlerts || []}
        handleDeleteAlert={handleDeleteAlert}
        callback={callback}
        i18n={i18n}
      />
    </>
  );

  const csaViolationFieldWaitingEnabled = () => <CsaViolation />;

  const potentialViolations = () => (
    <>
      <div className="viewAll">
        {checkServiceProvider('component_potentialViolations', SERVICE_PROVIDER, false) && (
          <Icon
            src={mediaUrls?.clearAll}
            onClick={() =>
              clearAll({
                apiId: 'clearAllPotentialData',
                callback: setValue(0),
              })
            }
            asLink={iconsAsLink}
            text={i18n.t('common.clearAll')}
            tooltip={i18n.t('common.clearAll')}
          />
        )}
        <Icon
          src={mediaUrls?.viewAll}
          onClick={() => history.push(pageUrls.potentialViolationsViewMore)}
          tooltip={i18n.t('common.viewMore')}
          asLink={iconsAsLink}
          text={i18n.t('common.viewMore')}
        />
      </div>
      <PotentialViolations i18n={i18n} potentialViolations={dashboard?.data?.driversAtRisk?.infoItems || []} />
    </>
  );

  const recentAccidents = () => (
    <>
      <div className="viewAll">
        <Icon
          src={mediaUrls?.clearAll}
          onClick={() => {
            clearAllRecentAccidents({
              apiId: 'clearAllAccidentsData',
              callback: setValue(0),
            });
          }}
          asLink={iconsAsLink}
          text={i18n.t('common.clearAll')}
          tooltip={i18n.t('common.clearAll')}
        />

        <Icon
          src={mediaUrls?.viewAll}
          onClick={() => history.push(pageUrls.accidentsList)}
          tooltip={i18n.t('common.viewMore')}
          asLink={iconsAsLink}
          text={i18n.t('common.viewMore')}
        />
      </div>
      <RecentAccidents i18n={i18n} recentAccidents={dashboard?.data?.recentAccidents?.infoItems || []} viewReport={viewReport} />
    </>
  );

  const dailyLogs = () => (
    <>
      <div className="viewAll">
        {checkServiceProvider('component_dailyLogs', SERVICE_PROVIDER, false) && (
          <Icon
            src={mediaUrls?.clearAll}
            onClick={() =>
              clearAllDailyLogs({
                apiId: 'clearAllDailyLogs',
                callback: setValue(0),
              })
            }
            asLink={iconsAsLink}
            text={i18n.t('common.clearAll')}
            tooltip={i18n.t('common.clearAll')}
          />
        )}
        <Icon
          src={mediaUrls?.viewAll}
          onClick={() => history.push(pageUrls.logsList)}
          tooltip={i18n.t('common.viewMore')}
          asLink={iconsAsLink}
          text={i18n.t('common.viewMore')}
        />
      </div>
      <DailyLogComponent i18n={i18n} data={dashboard?.data?.dailyLogs?.infoItems || []} viewReport={viewReport} />
    </>
  );

  const developerRequests = () => (
    <>
      <div className="viewAll">
        <Icon
          src={mediaUrls?.viewAll}
          onClick={() => history.push(pageUrls.alertsRequests)}
          asLink={iconsAsLink}
          text={i18n.t('common.viewMore')}
          tooltip={i18n.t('common.viewMore')}
        />
      </div>
      <DeveloperRequest
        list={dashboard?.data?.permissionAlerts?.dashboardAlerts || []}
        handleDeletePermissionRequest={handleDeletePermissionRequest}
        handleAcceptPermissionRequest={handleAcceptPermissionRequest}
        callback={callback}
        i18n={i18n}
      />
    </>
  );

  useEffect(() => {
    setNotificationEnabled(dashboard?.data?.enableNotification);
    const sourceToDisplay = sourceList.map((item) => {
      item.value = eval([item.id] + '()');
      item.name = i18n.t(item.nameKey);
      return item;
    });
    setSourceToDisplay(sourceToDisplay);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    dashboard.data,
    sourceList,
    dashboard?.data?.dailyLogs?.infoItems,
    dashboard?.data?.driversAtRisk?.infoItems,
    dashboard?.data?.recentAccidents?.infoItems,
    dashboard?.data?.enableNotification,
    notificationEnabled,
  ]);

  const isMapRequired = mapRequired === undefined || mapRequired;

  return (
    <>
      <Styled.Wrapper>
        <Styled.MapWrapper>
          {isMapRequired && (
            <GoogleMap
              type={'dashboardMap'}
              liveTracking={hasEnabledFeature('smoothTrackingEnabled')}
              height={'400px'}
              data={hasEnabledFeature('geometrisEnabled') ? dashboard?.vehicleStatusList : dashboard?.driverStatusList}
              getDriverStatus={getDriverStatus}
              dashboard={dashboard}
              viewOnMap={viewOnMap}
              viewOnMapFlg={viewOnMapFlg}
            />
          )}
        </Styled.MapWrapper>
        {accordion ? (
          <Accordion data={sourceToDisplay} />
        ) : (
          <Tab data={sourceToDisplay} currentTab={value} onChange={handleChange} className="tabs" />
        )}
      </Styled.Wrapper>
    </>
  );
};

Component.defaultProps = {
  accordion: false,
};
Component.propTypes = {
  history: PropTypes.object.isRequired,
  dashboard: PropTypes.object.isRequired,
  clearAll: PropTypes.func.isRequired,
  clearAllRecentAccidents: PropTypes.func.isRequired,
  refreshDriverStatus: PropTypes.func.isRequired,
  refreshVehicleStatus: PropTypes.func.isRequired,
  handleDeleteAlert: PropTypes.func.isRequired,
  callback: PropTypes.func.isRequired,
  clearAllAlerts: PropTypes.func.isRequired,
  enableNotification: PropTypes.func.isRequired,
  Styled: PropTypes.object.isRequired,
  accordion: PropTypes.bool,
};
export default Component;
